<template>
    <div>
        <strong>When will this message be sent</strong>
        <div v-if="template_context === 'birthday-message'">
            <ul>
                <li>RedChirp sends this message to customers on their birthday (adjusted by the "Day to send relative to birthday" parameter)</li>
                <li>You can set a delay (positive or negative) to send messages before or after the actual birthday</li>
            </ul>
        </div>
        <div v-if="template_context === 'birthday-month-message'">
            <ul>
                <li>RedChirp sends this message to all customers with birthdays in the current month</li>
                <li>The message is sent on a specific day of the month (configured in the "Day of month to send" parameter)</li>
                <li>This is useful for sending a single monthly message to all customers celebrating birthdays that month</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BirthdayMessageInfo',

    props: {
        template_context: {
            type: String,
            required: true
        }
    }
}
</script>
